<template>
    <div class="card">
        <highcharts :options="chartOptions" class="container"></highcharts>
    </div>
</template>
<script>
    import LineChart from "../Monitors/LineChart";

    export default {
        components: {
            highcharts: LineChart
        },
        props: {
            data: {
                type: Array,
                default: []
            },
            days: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'area'
                    },
                    title: {
                        text: 'Connection Data Processing'
                    },
                    xAxis: {
                        categories: this.days,
                        tickmarkPlacement: 'on',
                        title: {
                            enabled: false
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Connections'
                        },
                    },
                    tooltip: {
                        split: true,
                    },
                    plotOptions: {
                        area: {
                            stacking: 'normal',
                            lineWidth: 1,
                            marker: {
                                lineWidth: 1,
                            }
                        }
                    },
                    series: this.data
                }
            }
        }
    }
</script>
